import React, { memo } from "react";
import { GamePreviewDTO } from "../../../types/Game";
import { TicketRequestDTO } from "../../../types/TicketRequest";
import AdminRequestGame from "./AdminRequestGame";

type AdminRequestsViewProps = {
  schedule: number[];
  games: { [key: number]: GamePreviewDTO };
  requests: { [key: number]: TicketRequestDTO[] };
  jumpToRequestId?: number;
};

const AdminRequestsView = memo(({ schedule = [], games, requests, jumpToRequestId }: AdminRequestsViewProps) => (
  <>
    {schedule.map((gamePk: number) => (
      <AdminRequestGame
        key={gamePk}
        game={games[gamePk]}
        requests={requests[gamePk]}
        jumpToRequestId={jumpToRequestId}
      />
    ))}
  </>
));

export default AdminRequestsView;
